import { render } from "./PermReviewModal.vue?vue&type=template&id=50456602&scoped=true&ts=true"
import script from "./PermReviewModal.vue?vue&type=script&lang=ts"
export * from "./PermReviewModal.vue?vue&type=script&lang=ts"

import "./PermReviewModal.vue?vue&type=style&index=0&id=50456602&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50456602"]])

export default __exports__